export default __webpack_public_path__ + "media/images/features/yado/landscape-fb094a856325ef6711e98b39373e0881.png";